var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Alert, Snackbar, Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { Capacitor } from "@capacitor/core";
import { SafeArea } from 'capacitor-plugin-safe-area';
import ErrorCodes from '../../api/errorCodes';
import { toasterTimerError, toasterTimerSuccess } from '../../constants';
import { setSafeAreaMargin, showNotification } from "../../redux/commonSlice";
import { useAppSelector } from "../../store/hooks";
import { useState, useEffect } from 'react';
export var ToasterComponent = function (props) {
    var dispatch = useDispatch();
    var notification = useAppSelector(function (state) { return state.common.notification; });
    var safeAreaMargin = useSelector(function (state) { return state.common.safeAreaMargin; });
    // Shown toaster at bottom of the screen when keyboard is open
    var _a = useState(0), viewportBottom = _a[0], setViewportBottom = _a[1];
    var _b = useState(false), isKeyboardOpen = _b[0], setIsKeyboardOpen = _b[1];
    var _c = useState(false), isMobile = _c[0], setIsMobile = _c[1];
    useEffect(function () {
        var _window$visualViewpor, _window$visualViewpor2;
        // Check if mobile
        var checkMobile = function () {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        var updateBottom = function () {
            if (window.visualViewport) {
                var offset = window.innerHeight - (window.visualViewport.height + window.visualViewport.offsetTop);
                setViewportBottom(offset);
                var keyboardHeight = window.innerHeight - window.visualViewport.height;
                setIsKeyboardOpen(keyboardHeight > 150);
            }
            else {
                setViewportBottom(0);
                setIsKeyboardOpen(false);
            }
        };
        updateBottom();
        (_window$visualViewpor = window.visualViewport) === null || _window$visualViewpor === void 0 || _window$visualViewpor.addEventListener('resize', updateBottom);
        (_window$visualViewpor2 = window.visualViewport) === null || _window$visualViewpor2 === void 0 || _window$visualViewpor2.addEventListener('scroll', updateBottom);
        window.addEventListener('resize', updateBottom);
        return function () {
            var _window$visualViewpor3, _window$visualViewpor4;
            window.removeEventListener('resize', checkMobile);
            (_window$visualViewpor3 = window.visualViewport) === null || _window$visualViewpor3 === void 0 || _window$visualViewpor3.removeEventListener('resize', updateBottom);
            (_window$visualViewpor4 = window.visualViewport) === null || _window$visualViewpor4 === void 0 || _window$visualViewpor4.removeEventListener('scroll', updateBottom);
            window.removeEventListener('resize', updateBottom);
        };
    }, []);
    useEffect(function () {
        var fetchSafeAreaInsets = function () { return __awaiter(void 0, void 0, void 0, function () {
            var insets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(Capacitor.getPlatform() === 'ios')) return [3 /*break*/, 2];
                        return [4 /*yield*/, SafeArea.getSafeAreaInsets()];
                    case 1:
                        insets = (_a.sent()).insets;
                        dispatch(setSafeAreaMargin({
                            top: insets.top,
                            bottom: insets.bottom,
                            left: insets.left,
                            right: insets.right
                        }));
                        _a.label = 2;
                    case 2:
                        ;
                        return [2 /*return*/];
                }
            });
        }); };
        fetchSafeAreaInsets();
    }, []);
    var handleClose = function () {
        dispatch(showNotification({
            isOpen: false,
            message: notification.message,
            type: notification.type,
            isLinkToaster: notification.isLinkToaster,
            linkComponent: notification.linkComponent
        }));
    };
    var getStyles = function (severity) {
        switch (severity) {
            case 'success':
                return {
                    backgroundColor: '#0052ff',
                    color: '#ffffff'
                };
            case 'error':
                return {
                    backgroundColor: '#f5222d',
                    color: '#ffffff'
                };
            case 'warning':
                return {
                    backgroundColor: '#FFAB00',
                    color: '#1B1D21'
                };
            default:
                return {
                    backgroundColor: '',
                    color: ''
                };
        }
    };
    var styles = getStyles(notification.type);
    var shouldShowAtBottom = isMobile && isKeyboardOpen;
    var anchorOrigin = shouldShowAtBottom ? {
        vertical: "bottom",
        horizontal: "center"
    } : {
        vertical: "top",
        horizontal: "right"
    };
    var snackbarSx = shouldShowAtBottom ? {
        zIndex: 9999,
        marginBottom: "".concat(viewportBottom + ((safeAreaMargin === null || safeAreaMargin === void 0 ? void 0 : safeAreaMargin.bottom) || 0) + 16, "px")
    } : {
        zIndex: 9999,
        marginTop: "".concat(safeAreaMargin === null || safeAreaMargin === void 0 ? void 0 : safeAreaMargin.top, "px")
    };
    return notification.message ? /*#__PURE__*/ React.createElement(Snackbar, {
        open: notification.isOpen,
        autoHideDuration: notification.type === 'success' ? toasterTimerSuccess : toasterTimerError,
        anchorOrigin: anchorOrigin,
        onClose: handleClose,
        sx: snackbarSx,
        id: notification.type === 'success' ? 'successToast' : 'errorToast'
    }, /*#__PURE__*/ React.createElement(Alert, {
        elevation: 6,
        variant: "filled",
        onClose: handleClose,
        severity: notification.type,
        id: notification.type === 'success' ? 'successAlert' : 'errorAlert',
        sx: _objectSpread({}, styles)
    }, notification.isLinkToaster ? /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, null, notification.message), notification.linkComponent) : /*#__PURE__*/ React.createElement(ErrorCodes, {
        id: "popup-message",
        code: notification.message
    }))) : /*#__PURE__*/ React.createElement(React.Fragment, null);
};
